import BaseService from '../BaseService'
import axios from "axios";

class UserActivityService extends BaseService {
    constructor() {
        super('/user-activity');
    }

    async log(log, properties = null) {
        return axios.post(`${this.resource}?notificationOff`, {
            log,
            properties
        })
    }
}

export default new UserActivityService()
